import React, { useState } from 'react';
import { Form, Button, Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { createSubcontractor } from '../../../../services/SubcontractorService';

const AddSubcontractor = () => {
  const [program, setProgram] = useState('');
  const [name, setName] = useState('');
  const [number, setNumber] = useState('');
  const [pocname, setPocName] = useState('');
  const [pocemail, setPocEmail] = useState('');
  const [pocphone, setPocPhone] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createSubcontractor({
        program,
        name,
        number,
        pocname,
        pocemail,
        pocphone,
      });
      navigate('/settings/subcontractor/');
    } catch (error) {
      console.error('Error adding subcontractor', error);
    }
  };

  return (
    <div>
      <Card className="p-3">
        <h2>Add Subcontractor</h2>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group controlId="program" className="mb-3">
                <Form.Label>Program</Form.Label>
                <Form.Control
                  type="text"
                  value={program}
                  onChange={(e) => setProgram(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="name" className="mb-3">
                <Form.Label>Company Name</Form.Label>
                <Form.Control
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group controlId="number" className="mb-3">
                <Form.Label>Subcontract Number</Form.Label>
                <Form.Control
                  type="text"
                  value={number}
                  onChange={(e) => setNumber(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="pocname" className="mb-3">
                <Form.Label>POC Name</Form.Label>
                <Form.Control
                  type="text"
                  value={pocname}
                  onChange={(e) => setPocName(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group controlId="pocemail" className="mb-3">
                <Form.Label>POC Email</Form.Label>
                <Form.Control
                  type="email"
                  value={pocemail}
                  onChange={(e) => setPocEmail(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="pocphone" className="mb-3">
                <Form.Label>POC Phone</Form.Label>
                <Form.Control
                  type="text"
                  value={pocphone}
                  onChange={(e) => setPocPhone(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-end">
            <Button type="submit" variant="primary">
              Add Subcontractor
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default AddSubcontractor;
